<template>
  <div class="table-page-search-wrapper">
    <a-form layout="inline">
      <a-form layout="inline">
        <a-row :gutter="48">
          <a-col :md="6" :sm="24">
            <a-form-item label="市场名称">
              <a-input placeholder="请输入市场名称" v-model="searchModel.name" />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="跟进状态">
              <a-select
                allowClear
                placeholder="请选择跟进状态"
                v-model="searchModel.status">
                <a-select-option
                  :value="item.code"
                  v-for="(item,index) in statusList"
                  :key="index"
                >{{ item.name }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="市场类型">
              <a-select
                allowClear
                showSearch
                optionFilterProp="children"
                placeholder="请选择市场类型"
                v-model="searchModel.type"
              >
                <a-select-option v-for="(item, index) in marketTypeList" :key="index" :value="item.code">{{ item.name }}</a-select-option>
                <!-- <a-select-option :value="1">纯软件</a-select-option>
                <a-select-option :value="2">项目集成</a-select-option> -->
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <span
              class="table-page-search-submitButtons"
              :style="advanced && { float: 'right', overflow: 'hidden' } || {} "
            >
              <a-button type="primary" @click="search">查询</a-button>
              <a-button style="margin-left: 8px" @click="clearSearch">重置</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </a-form>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'MarketsSearchForm',
  mounted () {},
  data () {
    return {
      showExpend: false,
      searchModel: {},
      advanced: false // 是否展开
    }
  },
  computed: {
    statusList () {
      return this.$store.state.market.statusList
    },
    ...mapGetters(['marketTypeList'])
  },
  methods: {
    // 搜索框展开
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    // 点击查询按钮
    search () {
      const model = this.searchModel
      if (model.name) {
        model.name = model.name.trim()
      }
      for (var item in model) {
        if (!model[item]) {
          delete model[item]
        }
      }
      this.$emit('setSearchCondition', this.searchModel)
    },
    // 点击复位按钮
    clearSearch () {
      this.searchModel = {}

      this.$emit('clearSearch', this.searchModel)
    }
    // 获取select列表
  }
}
</script>

<style scoped>
</style>
